import { AfterViewInit, Component, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { Router } from '@angular/router';
import _ from 'lodash';
import { Carousel } from 'primeng/carousel';
import { QSliderConfig } from 'projects/ui-kit/src/lib/components/q-slider/q-slider.component';
import { interval } from 'rxjs';
import { takeWhile } from 'rxjs/operators';
import { APP_CONFIG, PRODUCT_CLICK_COUNT } from 'src/app/app.const';
import { MediaService } from 'src/app/shared/services/media.service';
import { BRAND_LOGOS_1, BRAND_LOGOS_2, OUTFIT_BLOCK, SLIDER_DATA, SMS_LIST } from './home.const';
import { AppService } from 'src/app/shared/services/app.service';
import { DiscoverService } from 'src/app/shared/services/discover.service';
import { AuthService } from 'src/app/shared/services/auth.service';
import { DeviceDetector } from 'projects/ui-kit/src/lib/services/device-detector.service';
import { ProductService } from 'src/app/shared/services/product.service';
import { LocalStorageService } from '@hss-m/uikit-common';
import { UserService } from 'src/app/shared/services/user.service';
import { QuickSignUpComponent } from '../../auth/quick-sign-up/quick-sign-up.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent extends DeviceDetector implements OnInit, AfterViewInit, OnDestroy {
  convoCards: any = [{}, {}, {}, {}]
  convoCardsLoading = true;
  brandsLogoList1 = BRAND_LOGOS_1
  brandsLogoList2 = BRAND_LOGOS_2
  svgWaveText = _.fill(Array(80), '');
  sliderIndex = 0;
  secondBlockConfig: QSliderConfig = {
    basePath: `${APP_CONFIG.FIREBASE.BASE_URL}qatch-home%2F`,
    numVisible: 1,
    circular: true,
    autoplayInterval: 10000
  };
  sliderItems = SLIDER_DATA;
  activeSlideItem = 1;
  isComponentDestroyed = false;
  smsBlock = {
    header: { title: ` Our Members Love Us`, subTitle: 'Here’s what they have to say about Qatch' },
    smsList: SMS_LIST
  };
  communityBlock = {
    header: { title: `Join the Qatch Community`, subTitle: 'See how Qatch members style their recommendations' },
    images: ['GIF-Left.gif', 'GIF-middle.gif', 'GIF-Right.gif']
  };
  getSocialBlock = {
    header: { title: `Let's get social`, subTitle: 'Follow us on social media' }
  };
  circleVideoBlock = {
    header: { title: 'Rate Your Recommendations', subTitle: `to help your virtual stylist learn what you love and don't love` },
  };
  outfitsBlock = OUTFIT_BLOCK;
  columns:any = [];
  firebaseBaseUrl = `${APP_CONFIG.FIREBASE.BASE_URL}qatch-home%2F`;
  medias: any[];
  productMapping = {};
  productMeta = {
    type: 'collections-product',
    pageType: '',
    pageOwnerId: null,
    uiTaggingKey: 'collections',
    alwaysShowRection: true
  };
  productClickCount = 0;
  maxClicksAllow = 2;
  specialists: any[];
  isLoggedIn: boolean;
  constructor(
    protected authService: AuthService,
    private router: Router,
    private renderer: Renderer2,
    private appService: AppService,
    private discoverService: DiscoverService,
    private mediaService: MediaService,
    private productService: ProductService,
    private userService: UserService,
    private lss: LocalStorageService,
    private modalService: NgbModal
  ) {
    super();
    this.device.subscribe(() => {
      this.onResizeScreen();
    })
    this.fetchProducts() ;
  }

  ngOnInit(): void {
    Carousel.prototype.onTouchMove = () => { };
    interval(5000).pipe(
      takeWhile(() => !this.isComponentDestroyed)
    ).subscribe(() => {
      if (this.activeSlideItem < this.sliderItems.length) {
        this.activeSlideItem++;
      } else {
        this.activeSlideItem = 1;
      }
    });
    this.mediaService.getTiktokPosts().then((resp: any) => {
      this.medias = resp.data || null;
    })
    this.appService.getConvoCardsData().subscribe((res: any) => {
      this.convoCards = res?.convos;
      this.convoCardsLoading = false;
    });
    this.isLoggedIn = this.authService.isLoggedIn();
    this.getCollection();
  }

  onResizeScreen() {
    this.secondBlockConfig.showNavigators = !this.isMobile;
    this.secondBlockConfig.showIndicators = this.isMobile;
  }

  getCollection() {
    this.specialists = [];
    this.discoverService.getCollectionTypes()
      .subscribe({
        next: types => {
          this.specialists = types;
        },
        error: (err) => {
          // this.toastService.error(`Unable to load collections. Please try again.`);
        },
      });
  }

  productClickCounter(key: string, storageKey: string) {
    this[key] = parseInt(this.lss.get(storageKey, '0'));
    this[key]++;
    this.lss.set(storageKey, `${this[key]}`);
  }

  onProductClick(product: any) {
      const isLoggedIn = this.authService.isLoggedIn();
      if (product.availability_id === 2 || !product.affiliate_link) return;
      this.productClickCounter('productClickCount', PRODUCT_CLICK_COUNT);
      // if (this.productClickCount > this.maxClicksAllow && !isLoggedIn) {
      //   this.openQuickSignUp();
      // } else {
      //   window.open(product.affiliate_link, '_blank');
      //   this.userService.logUserClick(product).subscribe();
      // }
  
      // Will remove below code after 1 Jan and uncomment above code
      window.open(product.affiliate_link, '_blank');
      this.userService.logUserClick(product).subscribe();
      if (this.productClickCount > this.maxClicksAllow && !isLoggedIn) {
        this.lss.remove(PRODUCT_CLICK_COUNT);
        this.openQuickSignUp();
      }
  }

  openQuickSignUp() {
      this.modalService.open(QuickSignUpComponent, {
        centered: true, size: 'md', windowClass: 'quick-popup'
      });
  }

  goToProfile(specialist) {
    window.open(`${location.origin}/discover/collections/${specialist.slug}`, "_blank");
  }

  ngAfterViewInit(): void {
    const script = this.renderer.createElement('script');
    script.id = "tiktokscript";
    script.src = 'https://www.tiktok.com/embed.js';
    this.renderer.appendChild(document.body, script);
  }

  override ngOnDestroy(): void {
    const script = document.getElementById("tiktokscript");
    this.renderer.removeChild(document.body, script);
    this.isComponentDestroyed = true;
    this.device?.unsubscribe();
  }

  onSignup() {
    this.appService.navigate('signup', { queryParamsHandling: "merge" });
  }


  switchPage(event?) {
    switch (event) {
      case "COLLECTIONS":
        this.router.navigate(['/discover/collections'], { queryParamsHandling: "merge" });
        break;
      case "IMPACT_COLLAB":
        window.open('https://qatch.style/impact-collab', '_blank')
        break;
      default:
        window.open('https://www.instagram.com/joinqatch/', '_blank');
        break;
    }
  }

  fetchProducts() {
    this.discoverService.getPopularRecommendations("popular-recommendations", { pageNumber: 1, pageSize: 8 }, {}, {}).subscribe(res => {
      this.getProductsWithLoveCount(res.data.map(p => p.product_id));
      if(res.data?.length > 5) {
        res.data[4].reaction_type = 'Loved';
      }
      this.columns = this.transforArray(res.data, this.isMobile ? 4 : 2);
    });
  }

  getProductsWithLoveCount(productIds) {
    this.productService.getProductsWithLoveCount(productIds)
    .subscribe( (res: {product_id: string, loved: number}[]) => {
      this.productMapping = (res || []).reduce( (o, n) => {
        o[n.product_id] = n.loved;
        return o;
      }, this.productMapping);
    });
  }

  transforArray(array, chunkSize) {
    const result = [];
    for (let i = 0; i < array.length; i += chunkSize) {
      result.push(array.slice(i, i + chunkSize));
    }
    return result;
  }

  openTiktokVideo(media) {
    window.open(`https://www.tiktok.com/@joinqatch/video/${media.id}`, '_blank');
  }

}
